module.exports = __webpack_public_path__ + "img/skype-color.39a4751e.svg";